var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.28 155.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#040405;}.cls-2{fill:#d7006c;}.cls-3{fill:#e13433;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    className: "cls-1",
    d: "M77.82,155.62h-28c-61.31,0-53.72-94.15-41.11-133.7a50.34,50.34,0,0,1,6.07-7.35A49.46,49.46,0,0,1,49.81,0h28a49.31,49.31,0,0,1,31.5,11.37,48.7,48.7,0,0,1,4.09,3.77c13.06,13.48,14.09,34.38,14.53,52.06.5,20.31,1.64,41.94-7.12,60.85-5.84,12.62-15.16,22-33,26.55a49.79,49.79,0,0,1-10,1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    className: "cls-2",
    d: "M76.87,121.33A12.92,12.92,0,1,1,64,108.41a12.92,12.92,0,0,1,12.91,12.92h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    className: "cls-3",
    d: "M73.19,121.33A9.24,9.24,0,1,1,64,112.09a9.22,9.22,0,0,1,9.24,9.24h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    className: "cls-2",
    d: "M36.59,15c1.1,1.28,15.47-4.64,37.13-1.76,10.54,1.4,17.18,4.14,18.09,3.18C93,15.21,84,8.5,72.73,6.35,53.67,2.73,35.27,13.51,36.59,15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    className: "cls-3",
    d: "M43.61,41.84c-.73,2.14-2.77,8.11.47,11.71,2.17,2.42,6.49,3.51,8.9,1.87,3.56-2.42.29-9,4.21-12.18,2.34-1.9,6.05-1.65,8.44-.46,5.53,2.73,5.61,11.26,5.62,12.64.1,11-8.64,21.08-10.78,23.43-2.67,2.94-5.8,5.6-6.56,10.3-.18,1.19-.73,4.63,1.41,7,2.72,3,8.44,2.93,10.77.47,2-2.08.56-4.78.94-8.9.68-7.32,6.19-9.66,11.25-16.87.62-.88,9-13.21,7-27.64C84.87,40.1,83.19,28,74.53,24c-11.15-5.15-27,6.25-30.92,17.8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/Icon9.3a0bc8a5819bf92879b16c9790c2ee2f.svg";
export { ForwardRef as ReactComponent };